import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect,useState} from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import {useGetCourseListQuery,useGetLearningOutcomeListQuery,useShowLearningOutcomeDetailQuery,useUpdateLearningOutcomeDetailMutation} from "../../../Services/api";
export default function Update(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        lpid: Yup.string().required("element name fields is required"),
        bullet_point: Yup.string().required("bullet point fields is required"),
        study_hours: Yup.string().required("study_hours fields is required"),
    });
      const {
        data: ShowLearningOutcome,
      } =  useShowLearningOutcomeDetailQuery({  params:props['id']});
     
      const [UpdateLearningOutcome,isLoading] = useUpdateLearningOutcomeDetailMutation();
      const Outcome= ShowLearningOutcome?.data[0];
     
      var  defaultValues={
        lpid:Outcome?.lpid,
        bullet_point:Outcome?.bullet_point,
        study_hours:Outcome?.study_hours,
    };
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[Outcome]) 
    const updateOutcome = (values,e) => {
        const formData = new FormData();
        formData.append('lpid', values.lpid);
        formData.append('bullet_point', values.bullet_point);
        formData.append('file', values.file[0]);
        formData.append('study_hours', values.study_hours);
        formData.append('id', props['id']);

        UpdateLearningOutcome(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error)
        });
        notify();
    };
    const [courseCode,setCourseCode] = useState(0);
    const findLession=(e)=>{
        setCourseCode(e.target.value);
    }
    const { 
        data: LearningOutcomeList        
     } = useGetLearningOutcomeListQuery({  params:courseCode});
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Outcome detail</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Outcome</h5>
                        <form onSubmit={handleSubmit(updateOutcome)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                <select  {...register("course_id", { required: true })} className="form-control" onChange={findLession}>
                                    <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.course_id && <span  className="text-danger">Course is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element</label>
                                <div className="col-sm-10">
                                <select  {...register("lpid", { required: true })} className="form-control">
                                    <option value="">Select Element</option>                                           
                                    {                            
                                    LearningOutcomeList?.data?.map((item) => {
                                        return (
                                            <option key={item.lpid} value={item.lpid}>{item.element_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.lpid && <span  className="text-danger">Element is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Bullet Point</label>
                                <div className="col-sm-10">
                                    <input type="name" {...register("bullet_point" ,{ required: true})} className="form-control" />
                                    {errors.bullet_point && <span  className="text-danger">Bullet Points is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">File Name</label>
                                <div className="col-sm-10">
                                    <input type="file" {...register('file' ,{ required: true })} className="form-control" />
                                    {errors.file && <span  className="text-danger">File Name is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Study Hours</label>
                                <div className="col-sm-10">
                                    <input type="number" {...register('study_hours' ,{ required: true })} className="form-control" />
                                    {errors.study_hours && <span  className="text-danger">Study Hours is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label"></label>
                                <div className="col-sm-10">
                                     {isLoading.status !='pending' ? 
                                                
                                        <button type="submit" className="btn btn-warning w-100" >Update Outcome Details</button>
                                                :
                                        <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                                </div>
                            </div>
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}